import { initDeleteLabelModal, initLabels } from '~/labels';

initLabels();
initDeleteLabelModal();
